module.exports = __webpack_public_path__ + "static/otm_real_estate-0e9f444923cf47a3acfd193f0ab2ddc7.png";